import React from 'react';
import { User, Phone, MessageCircle, Mail, Globe } from 'lucide-react';

// Agency footer: one wrapping row. Phone dials, WhatsApp opens a chat, email composes, website opens.
export const ContactRow = ({ c }) => {
  const items = [
    { key: 'person', Icon: User, text: c.person },
    { key: 'phone', Icon: Phone, text: c.phone, href: c.phone && `tel:${c.phone.replace(/\s/g, '')}` },
    { key: 'whatsapp', Icon: MessageCircle, text: c.phone && 'WhatsApp', href: c.whatsapp && `https://wa.me/${c.whatsapp}` },
    { key: 'email', Icon: Mail, text: c.email, href: c.email && `mailto:${c.email}` },
    { key: 'website', Icon: Globe, text: c.website, href: c.website_url || c.website },
  ].filter((x) => x.text);
  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-1" data-testid="view-contact-row">
      {items.map(({ key, Icon, text, href }) => {
        const inner = <><Icon className="w-[18px] h-[18px] shrink-0 text-[#6B7280]" aria-hidden="true" /><span className="break-all">{text}</span></>;
        const cls = 'inline-flex items-center gap-2 min-h-[44px] text-[15px] text-[#374151]';
        return href ? (
          <a key={key} href={href} target={key === 'website' || key === 'whatsapp' ? '_blank' : undefined} rel="noopener noreferrer"
            className={`${cls} hover:text-[var(--navy)] hover:underline`} data-testid={`contact-${key}-link`}>{inner}</a>
        ) : <span key={key} className={cls} data-testid={`contact-${key}`}>{inner}</span>;
      })}
    </div>
  );
};
